import {
    faExchangeAlt,
    faUserTimes,
    faShoePrints,
    faAlignJustify,
    faPollH,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import { RemoverAtendimentoDoUsuarioController } from "../../../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import { ListarAtendimentosRepasseController } from "../../../../../../Controllers/Repasse/GestaoAtendimentos/GestaoAtendimentosRepasse";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../../../../hooks/usePaginationFilter";
import { IAtendimentoCliente } from "../../../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import { IAtendimentoRepasse } from "../../../../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import { ACESSOS } from "../../../../../../Routes/Acessos";
import ModalComponent from "../../../../../Modais";
import { IComponentModal } from "../../../../../Modais/IModalComponent";
import Table from "../../../../../Table";
import AtendimentoCard, { ModuloAtendimento } from "../../../../Atendimento";
import TransferirAtendimento from "../../../../Atendimento/TransferirAtendimento";
import FiltroAtendimentosDoCliente from "../FiltroAtendimentosDoCliente";

interface IAtendimentosRepasseProps {
    ID_CONTA: number;
    dsModulo: ModuloAtendimento;
}

export default function AtendimentosAssitenciaTecnicaClienteDaConta(
    props: IAtendimentosRepasseProps
) {
    moment.locale("pt-br");

    const [totalPaginas] = useState(1);
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number[]>(
        []
    );
    const [categoriaAtendimento, setCategoriaAtendimento] = useState<number[]>(
        []
    );

    const [valueEtapa, setValueEtapa] = useState<Array<{
        label: string;
        value: number;
    }> | null>(null);

    const filtroInicial = {
        DT_INICIAL_IN: "",
        DT_INICIAL_FN: "",
        DT_FINAL_IN: "",
        DT_FINAL_FN: "",
        DS_STATUS_CASO: "",
        ID_MOTIVO_CANCELAMENTO: 0,
        ID_UNIDADE: 0,
        ID_PRODUTO: 0,
        FL_ANDAMENTO: 0,
        FL_CONTEM: false,
        PESQUISA: "",
        ID_USUARIO: 0,
        DS_NOME_CONTA: "",
        DS_NOME_CONTATO: "",
        ID_CATEGORIA_ATENDIMENTO: 0,
        ID_TIPO_CANAL_ATENDIMENTO: 0,
        ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS: 0,
        ID_TIPOS_PESOS_ATENDIMENTOS: [0],
        ID_CONTA: props.ID_CONTA,
        ID_ACOMPANHAMENTO: 0,
    };

    const FILTRO_ATENDIMENTOS_DO_CLIENTE_REPASSE = sessionStorage.getItem(
        "FILTRO_ATENDIMENTOS_DO_CLIENTE_REPASSE"
    );

    const { PageFilter, setPage, filter, setFilter } = usePaginationFilter<any>(
        {
            page: 1,
            filter: FILTRO_ATENDIMENTOS_DO_CLIENTE_REPASSE
                ? JSON.parse(FILTRO_ATENDIMENTOS_DO_CLIENTE_REPASSE)
                : filtroInicial,
        }
    );

    const handleDateChange = (formData: any) => {
        const filterFormData = {
            ...formData,
        };
        PageFilter.page = 1;
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_ATENDIMENTOS_DO_CLIENTE",
            JSON.stringify(filterFormData)
        );
    };

    const {
        value: lstAtendimentosRepasse,
        loading: lstAtendimentosRepasseLoading,
        execute: updateAtendimentos,
    } = useAsyncEffect(async () => {
        return ListarAtendimentosRepasseController(
            {
                ID_CONTA: props.ID_CONTA,
                ID_EMPREENDIMENTO: idEmpreendimento ?? [],
                DT_FINAL_FN: filter?.DT_FINAL_FN
                    ? filter?.DT_FINAL_FN
                    : undefined,
                DT_FINAL_IN: filter?.DT_FINAL_IN
                    ? filter?.DT_FINAL_IN
                    : undefined,
                DT_INICIAL_FN: filter?.DT_INICIAL_FN
                    ? filter?.DT_INICIAL_FN
                    : undefined,
                DT_INICIAL_IN: filter?.DT_INICIAL_IN
                    ? filter?.DT_INICIAL_IN
                    : undefined,
                ID_USUARIO: Number(filter?.ID_USUARIO)
                    ? Number(filter?.ID_USUARIO)
                    : 0,
                ID_CASO: filter?.ID_CASO ? filter?.ID_CASO : undefined,
                ID_CATEGORIA_ATENDIMENTO: filter?.ID_CATEGORIA_ATENDIMENTO
                    ? filter?.ID_CATEGORIA_ATENDIMENTO
                    : 0,
                DS_STATUS_CASO: filter?.DS_STATUS_CASO
                    ? filter?.DS_STATUS_CASO
                    : "",
            },
            1,
            "GERAL"
        );
    }, [props.ID_CONTA, PageFilter, filter]);

    function rowAtendimento(cell: any, row: IAtendimentoRepasse) {
        return (
            <AtendimentoCard
                atendimento={row}
                moduloAtendimento={props.dsModulo}
                setModal={setModal}
                setShow={setShow}
                compactar={true}
                atalhos={[
                    {
                        text: "Transferir Atendimento",
                        icon: faExchangeAlt,
                        action: (row) => {
                            const atendimento = row as IAtendimentoCliente;
                            setModal({
                                Component: () => (
                                    <TransferirAtendimento
                                        ID_CASO={row.ID_CASO}
                                        setShow={setShow}
                                        update={() =>
                                            updateAtendimentos(
                                                props.ID_CONTA,
                                                1
                                            )
                                        }
                                        ID_TIPO_CASO={
                                            ACESSOS.ASSISTENCIA.ID_MODULO
                                        }
                                        ID_USUARIO={
                                            atendimento.Atendimento.ID_USUARIO
                                        }
                                        ID_USUARIO_ACOMPANHAMENTO={
                                            atendimento.Atendimento
                                                .ID_USUARIO_ACOMPANHAMENTO
                                        }
                                    />
                                ),
                                IconHeader: faExchangeAlt,
                                headerComponent: "Transferir Atendimento",
                            });
                            setShow(true);
                        },
                    },
                    {
                        text: "Remover Atendente",
                        icon: faUserTimes,
                        action: () => {
                            Swal.fire({
                                title: `Deseja remover o vínculo de ${row.DS_ATENDENTE} a este atendimento?`,
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    RemoverAtendimentoDoUsuarioController(
                                        row.ID_CASO
                                    ).then(() => {
                                        updateAtendimentos(props.ID_CONTA, 1);
                                    });
                                }
                            });
                        },
                        condition: (a) => !!a.DS_ATENDENTE,
                    },
                ]}
            >
                <span
                    className="label label-light-info label-inline mr-2 my-1"
                    style={{ height: "auto" }}
                >
                    <FontAwesomeIcon icon={faShoePrints} className="mr-1" />{" "}
                    Etapa -{" "}
                    {row?.Atendimento?.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}
                </span>
                <span
                    className="label label-light-info label-inline mr-2 my-1"
                    style={{ height: "auto" }}
                >
                    <FontAwesomeIcon icon={faAlignJustify} className="mr-1" />{" "}
                    Categoria - {row?.Atendimento?.DS_CATEGORIA_ATENDIMENTO}
                </span>
                {row?.Atendimento?.DS_SUBCATEGORIA && (
                    <span
                        className="label label-light-info label-inline mr-2 my-1"
                        style={{ height: "auto" }}
                    >
                        <FontAwesomeIcon icon={faPollH} className="mr-1" />{" "}
                        Subcategoria - {row?.Atendimento?.DS_SUBCATEGORIA}
                    </span>
                )}
            </AtendimentoCard>
        );
    }
    //tabela
    const atendimentoColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO",
            text: "",
            formatter: rowAtendimento,
        },
    ];

    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                <div className="d-flex align-items-center justify-content-start">
                    <h4 className="text-dark font-weight-bold my-1 mr-5">
                        Atendimentos Repasse
                    </h4>
                </div>
            </div>
            <Table
                columns={atendimentoColumns}
                data={lstAtendimentosRepasse?.ATENDIMENTOS ?? []}
                keyField="ID_CASO"
                onTableChange={(type, newState) => {
                    setPage(newState.page);
                }}
                remote={{ pagination: true }}
                totalPages={totalPaginas}
                loading={lstAtendimentosRepasseLoading}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Atendimento encontrado
                    </div>
                )}
                noHover
                noSearch
                bordered={false}
            />
            <FiltroAtendimentosDoCliente
                FILTRO_ATENDIMENTOS_DO_CLIENTE={
                    FILTRO_ATENDIMENTOS_DO_CLIENTE_REPASSE
                }
                filter={filter}
                filtroInicial={filtroInicial}
                handleDateChange={handleDateChange}
                setFilter={setFilter}
                setPage={setPage}
                setIdEmpreendimento={setIdEmpreendimento}
                setCategoriaAtendimento={setCategoriaAtendimento}
                categoriaAtendimento={categoriaAtendimento}
                setValueEtapa={setValueEtapa}
                valueEtapa={valueEtapa}
                dsModulo={props.dsModulo}
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
